<template>
  <div :id="id" :class="className" tabindex="-1"><slot v-if="visible" /></div>
</template>

<script>
import Popper from 'popper.js'
import { toggle } from '../constant/utils.js'

export default {
  name: 'Pop',
  props: {
    visible: { type: Boolean, default: false },
    targetId: { type: String, default: undefined },
    id: { type: String, default: 'popper-wrapper' },
    className: { type: String, default: '' },
    placement: { type: [String || Array], default: '' },
    container: { type: String, default: undefined },
  },
  watch: {
    visible(val, oldVal) {
      if (val === oldVal) return
      if (val) {
        document.addEventListener('click', this.handleClose)
      } else {
        document.removeEventListener('click', this.handleClose)
      }
    },
    targetId(val, oldVal) {
      if (!val || val === oldVal) return
      try {
        this.init()
        this.$emit('update:visible', true)
      } catch (error) {
        console.error(error)
      }
    },
  },
  created() {
    const _this = this
    this.handleClose = function(e) {
      const dom = e.target
      if (!toggle(dom, toggle, _this.id)) {
        _this.$emit('update:visible', false)
      }
    }
  },
  methods: {
    init() {
      const reference = document.querySelector(`#${this.targetId}`)
      const warpper = document.querySelector(`#${this.id}`)
      this.popper = new Popper(reference, warpper, {
        // placement: this.placement || 'auto',
        preventOverflow: {
          boundariesElement: this.container ? this.$parent.$refs[this.container] : 'viewport',
        },
      })
    },
  },
}
</script>
